import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const LabscaleModel = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
    };

    // 🔥 Replace with actual images
    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FbioEngineering%2F1.png?alt=media&token=36e1bef0-0e38-455b-8a9c-b18509979586',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FbioEngineering%2F1.png?alt=media&token=36e1bef0-0e38-455b-8a9c-b18509979586'
    ];

    return (
        <Layout>
            {/* BREADCRUMB */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/">Bio-Engineering Instruments</a></li>
                </ul>
            </div>

            {/* TITLE */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Labscale - Model-Biocanvas LF /Biocanvas LF plus </h1>
                </div>
            </div>

            {/* MAIN SECTION */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* IMAGE SLIDER */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ textAlign: 'center' }}>
                                                <img
                                                    src={src}
                                                    alt="Labscale Model"
                                                    className="responsive"
                                                    style={{ maxHeight: '400px', objectFit: 'contain' }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        </div>

                        {/* DESCRIPTION */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Labscale - Model-Biocanvas LF /Biocanvas LF plus </h3>

                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                   Experience cutting-edge performance with our compact fermenter system, featuring a 7-inch wide touch TFT LCD for effortless control, powerful agitation from 10 to 1500 rpm driven by AC servo or BLDC motors, and a full suite of sensors—standard (temperature, pH, DO, anti-foam, ORP) with optional upgrades (OD, O₂, CO₂, MFC, MFM). Designed with electric heater-based temperature control, whisper-quiet operation under 55 dB(A), and robust 10A fuse protection, this lightweight 10 kg unit runs seamlessly on AC110–220V, 50/60Hz power. Compact, reliable, and versatile, it’s the ideal solution for laboratories seeking precision, flexibility, and user-friendly performance in microbial and cell culture experiments.

                                    <br /><br />

                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Labscale Fermenter Model"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default LabscaleModel